import React from 'react';
import { TabsContent } from '@/components/ui/tabs';
import { OvertimeSettingsTab } from '@/components/settings/OvertimeSettingsTab';
import { TabAccessAlerts } from './TabAccessAlerts';
import type { SettingsFormState } from '../hooks/useSettingsFormState';
import type { OvertimeType } from '@/types/timesheetSettings';

interface OvertimeTabProps {
  form: SettingsFormState;
  canEditWorkType: boolean;
  companyId?: string;
  overtimeTypes: OvertimeType[];
  refetchOvertimeTypes: () => Promise<void>;
}

export const OvertimeTab: React.FC<OvertimeTabProps> = ({
  form,
  canEditWorkType,
  companyId,
  overtimeTypes,
  refetchOvertimeTypes,
}) => {
  const { overtimeSettings, tabsWithChanges, handleOvertimeSettingsChange } = form;

  return (
    <TabsContent value="overtime" className="space-y-6">
      <TabAccessAlerts
        canEdit={canEditWorkType}
        hasChanges={tabsWithChanges.has('overtime')}
        viewOnlyText="You have view-only access to Work Type. Contact your administrator to request edit access."
        unsavedText={<>You have unsaved changes. Click &quot;Save Settings&quot; at the bottom to apply your changes.</>}
      />
      <OvertimeSettingsTab
        settings={overtimeSettings}
        onChange={handleOvertimeSettingsChange}
        companyId={companyId}
        types={overtimeTypes}
        onTypesChange={refetchOvertimeTypes}
        canEdit={canEditWorkType}
      />
    </TabsContent>
  );
};
